import script from "./MarkdownEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"MarkdownEditor.vue"]])

export default __exports__